module.exports = __webpack_public_path__ + "e3e05142dd6c1c0247524aa9030f96c8.svg";